/**
* data.util.ts
*/
import { addDays, addHours, addMonths, endOfMonth, format, parseISO, setHours, setMinutes, setSeconds, startOfMonth, subMinutes } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

export class DateUtil {

  static createDateInTimeZone(date: Date, timeZone: string = 'America/Sao_Paulo'): Date {
    return utcToZonedTime(date, timeZone);
  }

  static toFormart(dateStrOrDate: string | Date, formatDate = 'dd/MM/yyyy', timezone = 'America/Sao_Paulo'): string {
    let dated = (typeof dateStrOrDate === 'string' ? parseISO(dateStrOrDate) : dateStrOrDate);
    dated = utcToZonedTime(dated, timezone);
    dated.toLocaleString('pt-BR', {
      timeZone: timezone
    });
    return format(dated, formatDate);
  }

  static getDateAddDays(amountDays: number, date: Date = new Date()) {
    date = utcToZonedTime(date, 'America/Sao_Paulo');
    date.toLocaleString('pt-BR', {
      timeZone: 'America/Sao_Paulo'
    });
    date = setHours(date, 0);
    date = setMinutes(date, 0);
    date = setSeconds(date, 0);
    return addDays(date, amountDays);
  }

  static getDateAddMonths(amountMonths: number, date: Date = new Date()) {
    date = utcToZonedTime(date, 'America/Sao_Paulo');
    date.toLocaleString('pt-BR', {
      timeZone: 'America/Sao_Paulo'
    });
    date = setHours(date, 0);
    date = setMinutes(date, 0);
    date = setSeconds(date, 0);
    return addMonths(date, amountMonths);
  }

  static getDateAddDaysInitialTime(amountDays: number, date: Date = new Date()) {
    date = utcToZonedTime(date, 'America/Sao_Paulo');
    date.toLocaleString('pt-BR', {
      timeZone: 'America/Sao_Paulo'
    });
    date = setHours(date, 0);
    date = setMinutes(date, 0);
    date = setSeconds(date, 0);
    let newDate = addDays(date, amountDays);
    let day = newDate.getDate();
    let month = newDate.getMonth();
    let year = newDate.getFullYear();
    let newDateInitial = new Date(Date.UTC(year, month, day, 0, 0, 0));
    newDateInitial.setTime(newDateInitial.getTime() + newDateInitial.getTimezoneOffset() * 60 * 1000); // deserializa
    return newDateInitial;
  }

  static getDateAddDaysFinalTime(amountDays: number, date: Date = new Date()) {
    date = utcToZonedTime(date, 'America/Sao_Paulo');
    date.toLocaleString('pt-BR', {
      timeZone: 'America/Sao_Paulo'
    });
    date = setHours(date, 0);
    date = setMinutes(date, 0);
    date = setSeconds(date, 0);
    let newDate = addDays(date, amountDays);
    let day = newDate.getDate();
    let month = newDate.getMonth();
    let year = newDate.getFullYear();
    var newDateFinal = new Date(Date.UTC(year, month, day, 23, 59, 59));
    newDateFinal.setTime(newDateFinal.getTime() + newDateFinal.getTimezoneOffset() * 60 * 1000); // deserializa
    return newDateFinal;
  }

  static getDateAddMonthInitialTime(amountMonth: number, date: Date = new Date()) {
    date = utcToZonedTime(date, 'America/Sao_Paulo');
    date.toLocaleString('pt-BR', {
      timeZone: 'America/Sao_Paulo'
    });
    date = setHours(date, 0);
    date = setMinutes(date, 0);
    date = setSeconds(date, 0);
    let newDate = addMonths(date, amountMonth);
    let day = newDate.getDate();
    let month = newDate.getMonth();
    let year = newDate.getFullYear();
    let newDateInitial = new Date(Date.UTC(year, month, day, 0, 0, 0));
    newDateInitial.setTime(newDateInitial.getTime() + newDateInitial.getTimezoneOffset() * 60 * 1000); // deserializa
    return newDateInitial;
  }

  static getDateAddMonthFinalTime(amountMonth: number, date: Date = new Date()) {
    date = utcToZonedTime(date, 'America/Sao_Paulo');
    date.toLocaleString('pt-BR', {
      timeZone: 'America/Sao_Paulo'
    });
    date = setHours(date, 0);
    date = setMinutes(date, 0);
    date = setSeconds(date, 0);
    let newDate = addMonths(date, amountMonth);
    let day = newDate.getDate();
    let month = newDate.getMonth();
    let year = newDate.getFullYear();
    var newDateFinal = new Date(Date.UTC(year, month, day, 23, 59, 59));
    newDateFinal.setTime(newDateFinal.getTime() + newDateFinal.getTimezoneOffset() * 60 * 1000); // deserializa
    return newDateFinal;
  }

  static getFirstAndLastDateOfTheMonth(year: number, month: number) {
    let date = new Date(year, month);
    date = utcToZonedTime(date, 'America/Sao_Paulo');
    const startDate = startOfMonth(date);
    const endDate = endOfMonth(date);

    return { startDate, endDate };
  }

  static getDate24HoursAgo() {
    let date = new Date();
    date = utcToZonedTime(date, 'America/Sao_Paulo');
    date.toLocaleString('pt-BR', {
      timeZone: 'America/Sao_Paulo'
    });
    let newDate = addHours(date, -23);
    let day = newDate.getDate();
    let month = newDate.getMonth();
    let year = newDate.getFullYear();
    let hours = newDate.getHours();
    let mins = newDate.getMinutes();
    let secs = newDate.getSeconds();
    var newDateFinal = new Date(Date.UTC(year, month, day, hours, mins, secs));
    newDateFinal.setTime(newDateFinal.getTime() + newDateFinal.getTimezoneOffset() * 60 * 1000); // deserializa
    return newDateFinal;
  }

  static getExpirationConversationDate() {
    return addDays(new Date(), 1);
  }

  static getDateSubtractMinuts(amountMinutes: number, date: Date = new Date()) {
    date = utcToZonedTime(date, 'America/Sao_Paulo');
    date.toLocaleString('pt-BR', {
      timeZone: 'America/Sao_Paulo'
    });
    return subMinutes(date, amountMinutes);
  }

  static getDiffMinutesFromDate(date: Date): number {
    const now = utcToZonedTime(new Date(), 'America/Sao_Paulo');
    date = utcToZonedTime(date, 'America/Sao_Paulo');
    const mileseconds = now.getTime() - date.getTime();
    return ((mileseconds / 1000) / 60); // mileseconds seconds and then to minutes
  }

  static getDateSubstractDays(days: number): Date {
    const date: Date = utcToZonedTime(new Date(), 'America/Sao_Paulo');
    date.setDate(date.getDay() - days);
    return date;
  }

  static getDateSubstractHours(hours: number): Date {
    const date: Date = utcToZonedTime(new Date(), 'America/Sao_Paulo');
    date.setHours(date.getHours() - hours);
    return date;
  }

  static getDateSubstractMinutes(minutes: number): Date {
    const date: Date = utcToZonedTime(new Date(), 'America/Sao_Paulo');
    date.setMinutes(date.getMinutes() - minutes);
    return date;
  }

  static secondsToHHMMSS(totalSeconds: number): string {
    if (!totalSeconds || totalSeconds < 0) return '00:00:00';

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);

    const pad = (v: number) => String(v).padStart(2, '0');

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  static minutesToHHMMSS(totalMinutes: number): string {
    if (!totalMinutes || totalMinutes < 0) return '00:00:00';

    const totalSeconds = totalMinutes * 60;

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.round(totalSeconds % 60);

    const pad = (v: number) => String(v).padStart(2, '0');

    const fixedMinutes = seconds === 60 ? minutes + 1 : minutes;
    const fixedSeconds = seconds === 60 ? 0 : seconds;

    const fixedHours = fixedMinutes === 60 ? hours + 1 : hours;
    const finalMinutes = fixedMinutes === 60 ? 0 : fixedMinutes;

    return `${pad(fixedHours)}:${pad(finalMinutes)}:${pad(fixedSeconds)}`;
  }

  /**
   * The calendar day a date filter sends (`dateStart` / `dateEnd` as `yyyy-MM-dd`): the user's
   * calendar day, never an instant — the server brackets it in the company's zone, so the window
   * does not depend on where the browser is. Anything that is not a valid `Date` passes through as
   * text, so a value already in that shape is kept as it is.
   */
  static toCalendarDay(value: string | Date): string {
    if (!(value instanceof Date) || isNaN(value.getTime())) {
      return `${value ?? ''}`;
    }

    return format(value, 'yyyy-MM-dd');
  }

  /** The local-midnight `Date` of a `yyyy-MM-dd` day, for a datepicker. Null for anything else. */
  static fromCalendarDay(day: unknown): Date | null {
    if (typeof day !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(day)) return null;

    const [year, month, dayOfMonth] = day.split('-').map(Number);
    return new Date(year, month - 1, dayOfMonth);
  }

}
